export const filters = {
    'all': 'all',
    'in review': 'awaiting',
    declined: 'declined',
    approved: 'approved',
    'partially fulfilled': 'partially-fulfilled',
    fulfilled: 'fulfilled',
};

export const displayStatus = {
    'all': 'all',
    'awaiting': 'awaiting approval',
    'declined': 'declined',
    'approved': 'approved',
    'partially-fulfilled': 'partially fulfilled',
    'fulfilled': 'fulfilled',
};
